export default __webpack_public_path__ + "images/cb25021e01adf740a0eadde9512467dc-avatar-yellow.svg";